import {
    LAUNCHDARKLY_FLAG_KEY_MAP,
    getEnvFeatureFlagDefaults,
} from 'src/config/featureFlags';

/**
 * Converts a raw LaunchDarkly flag object (LD keys) into internal keys.
 * Only keys present in LAUNCHDARKLY_FLAG_KEY_MAP are considered.
 *
 * @param {Record<string, unknown>} launchDarklyFlags
 * @returns {Record<string, boolean>}
 */
export const mapLaunchDarklyFlagsToInternal = (launchDarklyFlags = {}) => {
    const internalFlags = {};

    Object.entries(LAUNCHDARKLY_FLAG_KEY_MAP).forEach(([internalKey, ldKey]) => {
        if (Object.prototype.hasOwnProperty.call(launchDarklyFlags, ldKey)) {
            internalFlags[internalKey] = Boolean(launchDarklyFlags[ldKey]);
        }
    });

    return internalFlags;
};

/**
 * Merges env defaults with LaunchDarkly values (LD wins when present).
 *
 * @param {Record<string, unknown>} launchDarklyFlags
 * @returns {Record<string, boolean>}
 */
export const resolveFeatureFlags = (launchDarklyFlags = {}) => ({
    ...getEnvFeatureFlagDefaults(),
    ...mapLaunchDarklyFlagsToInternal(launchDarklyFlags),
});

/**
 * @param {Record<string, boolean>} featureFlags
 * @param {string|undefined|null} flagKey
 * @returns {boolean}
 */
export const isFeatureFlagEnabled = (featureFlags, flagKey) => {
    if (!flagKey) {
        return true;
    }
    return featureFlags[flagKey] === true;
};
